export default __webpack_public_path__ + "static/media/filpoll01.ace44fa8.png";